import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";
import theme from "../../../../Consts/Theme";
import heroMobile2026 from "./Static/hero-mobile2026.png";
import HeroCardNumbers from "./HeroCardNumbers";
import ButtonBasic from "../../../../Components/ButtonBasic/ButtonBasic";
import Wrapper from "../../../../Components/Wrapper/Wrapper";
import HeroCardMaxStudents from "./HeroCardMaxStudents";

// styled-components
const StyledContainer = styled.section`
  background-color: #000;
  padding-top: 100px;
  padding-bottom: 0;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const StyledHeroContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  h1 {
    color: #fff;
    font-family: Raleway;
    font-size: 40px;
    font-style: normal;
    font-weight: 800;
    line-height: 48px;
    letter-spacing: -0.5px;
    margin: 0;
    text-transform: uppercase;
  }

  p.subheading {
    color: #fff;
    font-family: Raleway;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px;
    margin: 20px 0 0 0;
  }

  @media (max-width: 374px) {
    h1 {
      font-size: 36px;
      line-height: 40px;
    }
    p.subheading {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

const StyledCTAContainer = styled.div`
  width: 100%;
  margin-top: 28px;
  div {
    width: 100%;
  }
  button {
    width: 100%;
  }
`;

const StyledFooter = styled.footer`
  margin-top: 32px;
`;

const StyledHeroImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  margin-top: 28px;
`;

const HomepageHeroMobile = ({ handleScrollToSection, landingNumbers }) => {
  const { t } = useTranslation();
  return (
    <StyledContainer>
      <Wrapper>
        <StyledHeroContent>
          <h1>
            Приемниот
            <br />
            тест е отворен
          </h1>
          <p className="subheading">
            Студирај БЕСПЛАТНО!
            <br />
            Brainster Next - практичен IT факултет!
          </p>
          <StyledFooter>
            <HeroCardNumbers
              numbers={landingNumbers}
              bgColor={theme.lightDark}
            />
            <HeroCardMaxStudents />
          </StyledFooter>
          <StyledCTAContainer>
            <ButtonBasic
              variation="extra-large"
              filling={"altBlue"}
              text={t("homepage.hero_section.cta")}
              onClick={handleScrollToSection}
            />
          </StyledCTAContainer>
          <StyledHeroImage src={heroMobile2026} alt="" aria-hidden="true" />
        </StyledHeroContent>
      </Wrapper>
    </StyledContainer>
  );
};

export default HomepageHeroMobile;
